import React from "react";
import { Helmet } from "react-helmet-async";
import { useLanguage } from "@/context/LanguageContext";

const SEO = ({ title, description, path = "/", image, keywords }) => {
  const { lang } = useLanguage();
  const fullTitle = title
    ? `${title} · Rota Yachting`
    : "Rota Yachting · Beyond the Ordinary Yacht Agency in Türkiye";
  const desc =
    description ||
    "Premium yacht agency services in Türkiye — port clearance, berth reservations, customs, provisioning, crew logistics, technical support and concierge.";
  const url = `https://rotayachting.com.tr${path}`;
  const img =
    image ||
    "/assets/photos/stock-83cb536f88ae.png";

  return (
    <Helmet>
      <html lang={lang} />
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      {keywords ? <meta name="keywords" content={keywords} /> : null}
      <link rel="canonical" href={url} />
      <link rel="alternate" hrefLang="en" href={url} />
      <link rel="alternate" hrefLang="ru" href={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={img} />
      <meta property="og:locale" content={lang === "ru" ? "ru_RU" : "en_US"} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={img} />
      <script type="application/ld+json">{JSON.stringify({
        "@context": "https://schema.org",
        "@type": "Organization",
        "name": "Rota Yachting",
        "url": "https://rotayachting.com.tr",
        "logo": img,
        "slogan": "Beyond the Ordinary",
        "description": desc,
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Meydankapı Mah. Denizciler Yolu, Rota Business Center No:1/1-2",
          "addressLocality": "Sinop",
          "addressCountry": "TR"
        },
        "contactPoint": [{
          "@type": "ContactPoint",
          "contactType": "customer service",
          "email": "yachting@rotayachting.com.tr",
          "telephone": "+90 368 261 88 74",
          "availableLanguage": ["English", "Russian", "Turkish"]
        }]
      })}</script>
    </Helmet>
  );
};

export default SEO;
